<template>
  <div class="main">
    <header class="header">
      <div class="header__logo">
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 800 600"
        >
          <path
            d="M488.2 146.1c-8.5 1.4-8.5 1.4-4.5 10.1 2.9 6.4 4 7.8 5.9 7.8 1.8 0 2.3-.7 2.8-3.8 1-6.9 1.8-15.2 1.5-15.1-.2.1-2.8.5-5.7 1zM502.6 156.2c-.6 9.7-.2 11.7 2.4 11.8.7 0 10.9-16.6 11.3-18.2.1-.6-2-1.7-4.8-2.4-8.5-2.3-8.1-2.6-8.9 8.8zM465.8 154.9c-2.5 1.6-4.8 3.3-5.1 3.8-.3.5 2.1 3.1 5.4 5.7 5.4 4.4 6.3 4.8 8.5 3.8 1.3-.7 2.4-1.6 2.4-2.1 0-1.8-4.8-13.5-5.7-13.8-.5-.2-2.9 1-5.5 2.6zM519.2 163.6c-3.3 6.5-5 11-4.4 11.6.6.6 5.1-1.7 11.6-5.8 10.3-6.6 10.5-6.8 8.8-8.7-1.9-2.2-9.2-7.7-10.1-7.7-.4 0-3 4.8-5.9 10.6zM448.5 171.1l-4.7 6.4 8.4 2.1 8.3 2.1 1.7-2.1c1-1.2 1.8-2.6 1.8-3.1 0-.6-2.4-3.5-5.4-6.4l-5.4-5.4-4.7 6.4zM531.9 177c-5.7 4.5-10.5 8.5-10.7 9.1-.8 2 3.3 2 15.5-.1 7-1.1 12.9-2.3 13.1-2.5.6-.6-4.9-12.4-6.3-13.5-.9-.8-4 1.1-11.6 7zM440.6 189.7c-.3 2.1-.6 5-.6 6.4v2.6l6.3-.9c10.7-1.5 10.9-1.6 10.5-4.5-.3-2.3-1.2-2.9-7.2-5-3.9-1.2-7.3-2.3-7.7-2.3-.3 0-.9 1.7-1.3 3.7zM538 194.6c-5.8 1.3-11.5 2.6-12.7 2.9-5 1.2-1.9 3.2 11.4 7.2 7.6 2.3 14 3.9 14.3 3.7.3-.3.7-4.1.9-8.5.4-9.3 1.6-8.8-13.9-5.3zM518.6 214.2l-2.6 4 6.5 8.8c9.2 12.3 8.8 12.1 13.7 7.4 4.2-4 9.8-12 9.8-13.8 0-.6-2.6-2.1-5.8-3.2-3.1-1.2-8.7-3.3-12.3-4.7l-6.7-2.5-2.6 4z"
          />
          <path
            d="M557.2 215c-.9 1.6-3.3 5.8-5.2 9.1-7.4 13.1-23.1 26.5-39.4 33.8-3.7 1.7-11.9 4.7-18.2 6.7-6.2 2-12.8 4.5-14.5 5.7-2.1 1.5-6.7 8.3-14 20.7-6 10.2-10.9 18.8-10.9 19.1 0 .4 4.2 1.7 9.3 2.9 5 1.3 9.7 2.6 10.2 2.9.6.3-9.8.8-23 1.1-31.5.7-28.2-1-49.5 25.7-5.8 7.3-10.9 13.2-11.3 13.3-.5 0-9.8-8.7-20.8-19.2-11-10.6-21.2-20-22.7-20.8-2.1-1.1-9.5-1.6-32-2.4-16.1-.5-29.4-.7-29.6-.5-.5.6 2.2 43 2.8 43.6 1.4 1.4 2.5-1.7 4.6-13.6 1.3-7.1 2.6-13.5 3-14.1.7-1.2 35.1-6.9 41.8-7 6.1 0 9.1 1.8 23.7 14.8 7.2 6.4 13.1 11.7 13.3 11.8.2.1.2 1.9 0 3.9l-.3 3.7-15.3-13c-19.3-16.4-18.5-16.2-38.7-12-8.2 1.6-15.1 3.1-15.2 3.2-.2.2 1.1 2.8 2.7 5.8l3 5.6 10.8-3.4c11.4-3.6 14.5-4 18.7-2.4 2.2.8 31.4 19 33.8 21 .4.4.5 1.9.2 3.3l-.7 2.5-14.1-8.2c-15.9-9.2-19.2-10.6-25.2-10.6-3.5 0-17.9 4-19.2 5.4-.3.3 4.2 10.2 5.2 11.4.1.1 3.2-1.2 7-2.9 10.3-4.9 14-4.5 31.8 3.1 14.1 5.9 14.7 6.3 14.7 9.1 0 1.6-.4 2.9-.9 2.9s-6.5-2.1-13.2-4.6c-15.2-5.7-20.2-6.2-28.9-3.2l-6.5 2.3.4 4.5c.1 2.5.5 4.7.7 4.9.2.2 3.9-.6 8.3-1.7 9.7-2.7 11.6-2.7 31.5-.1 11.4 1.5 16.5 2.6 17.4 3.7 3.2 4.1 2.6 4.2-28.8 4.2h-30l-3 6-3 6H398.3l-.5-6.3c-.5-6.4-3.4-13.4-7-17.4-1.8-1.9-2-3-1.4-7.4.7-5.1 1.2-5.8 14.8-20.2 14.1-14.7 18.2-17.9 24.8-19.2 3.1-.5 35.6 3.8 36.8 4.9.5.6-2 8.6-2.7 8.6-.3 0-7.3-1.3-15.6-3-20.6-4-21.5-3.8-35.3 10.3-4.4 4.4-7.3 8.1-7 9.1.2 1.2 2.2 0 7.8-4.8 9.1-7.6 12.7-9.6 17.7-9.6 2.9 0 28.7 6.5 30.1 7.6.2.1.1 1.6-.3 3.2l-.6 2.9-14-2.9c-9.2-2-15.2-2.8-17.5-2.4-2.2.5-6.7 3.4-12.7 8.3-5 4.2-9.4 7.7-9.5 7.9-.2.1-.2 1 0 1.8.2 1.2 2.4.2 9.3-4.4 12.7-8.5 11.7-8.5 35.3-1.4 8 2.5 8.2 2.6 7.6 5.2-.4 1.5-.9 3-1.3 3.4-.3.4-5.6-.6-11.6-2.3-15.1-4.1-18.5-3.8-29.7 3.2-4.9 2.9-8.8 5.9-8.8 6.6 0 1.7-.2 1.8 9.2-2.1 4.6-1.9 9.7-3.6 11.3-4 4.4-.8 41 8.5 41 10.4 0 1.3-4.5 1.5-30.5 1.8l-30.6.2-2.7 5.5c-1.5 3.1-2.7 5.8-2.7 6 0 .3 19.4.5 43.1.5h43.2l-.7-5.7c-.7-6.3-3.4-13.1-7.1-18l-2.5-3.2 2-13.3c1.8-11.8 3.2-16.4 12.2-40.6l10.1-27.4 9.4-8c12.3-10.5 11.4-12.2-2.7-5.3-11.5 5.6-15.6 9.5-22 20.5-2.4 4.1-4.5 6.9-4.8 6.1-.7-2.2 3-17.8 5.2-21.8s3.1-4.5 23.6-14.2c24.7-11.8 41.3-26.8 51.4-46.9 2.1-4.1 2.4-5.7 1.6-7.2-1.6-2.9-4.8-2.5-6.8 1z"
          />
          <path
            d="M454.5 218.5c-.5.2-8.5 2-17.6 4l-16.6 3.7-2.6 8.3-2.7 8.2-5.3.7c-2.8.3-7.5.6-10.2.6-4.8 0-5.3.3-10.9 5.9l-5.9 6-6.8-5.5-6.7-5.5-10 .3-10 .3 13.1 9.6c7.3 5.2 14.2 11 15.4 12.8 1.2 1.7 3 6.6 4 10.9 1.6 6.7 1.9 7.3 2.4 4.7.4-1.7.7-4.6.8-6.6.2-7.5 4.2-12.7 17-22.7 6.6-5 12.3-9.2 12.6-9.2.4 0 .5 1.4.1 3.1-.8 4.1-1 4.2 20-8.7 9.5-5.7 19.1-11.1 21.4-11.9 5.7-2 13.8-1.9 29.5.5 7.2 1.1 13.5 2 14.2 2 .7 0 3.5 4.3 6.3 9.5l5.1 9.4 4.7-1.8c2.6-1 5.5-2.1 6.5-2.4 1.6-.6.9-1.8-4.9-9-3.7-4.5-7.2-8.7-7.8-9.4-2-2.1-51.3-9.1-55.1-7.8z"
          />
          <path
            d="M462.8 237c-1.5.4-12.6 6.1-24.8 12.5-12.2 6.4-22.3 11.5-22.5 11.4-.1-.2-.7-2.3-1.2-4.5l-.8-4.2-9.3 7.9c-5.4 4.7-10 9.6-11.2 12-1.2 2.2-3.4 10.3-4.9 18-1.6 7.7-3 14.2-3.3 14.4-.2.2-2.4-5.1-4.8-11.8-5.2-14.6-8-20.5-11.2-23.3-1.2-1.1-8.5-6.5-16.2-11.9l-13.8-9.7-8.4 3.7c-13.7 6.1-14.4 5 10.2 14.9 12.1 4.8 23.4 9.9 25.2 11.3 2.4 1.8 5.5 6.9 11.6 19.4l8.4 16.9 6.3-18.7c6-18.1 6.4-18.9 11.3-23.8 2.8-2.8 6.5-6.1 8.3-7.3l3.1-2.2 2.1 5.5c1.2 3.1 2.1 5.9 2.1 6.4 0 .4-1.9 1.8-4.2 3.1-8.2 4.4-10.1 7.1-19.4 28-4.8 10.9-9.1 19.7-9.5 19.4-.4-.2-5.3-8.4-11-18.1-5.7-9.7-11.5-19-12.9-20.5-1.9-2.1-8.8-5.2-27.5-12.3l-25-9.6-4.7 5.3c-2.6 2.9-4.4 5.6-4 5.9.4.3 12.2 3.5 26.2 6.9 14 3.5 26.7 6.9 28.1 7.6 3.7 1.9 7 5.9 19.9 24.7 6.3 9.2 11.7 16.7 12 16.7.3 0 4.5-7.5 9.4-16.8 10.8-20.5 12.2-22.4 18.8-25.5 9.5-4.5 9.8-4.4 16.4 2.6l5.9 6.2-8.5.6c-8.7.5-14.7 2.7-18.1 6.5-.9 1.1-6.3 9.9-11.9 19.7-5.6 9.8-10.6 17.7-11 17.5-.5-.2-7.5-9.1-15.7-19.8-18.9-24.8-17.5-23.9-49-31.5-13-3.2-24.9-5.8-26.6-5.9-2.9-.1-3.2.2-6.3 8.2-2.3 5.7-2.9 8.4-2.1 8.7.7.2 13.1 1.3 27.7 2.4 34.8 2.8 32.8 1.9 55.1 25.5 9 9.6 16.9 17.3 17.4 17.2.6-.2 6.2-7.4 12.6-16.2 14.5-19.9 17-21.9 27.7-21.9 4.3 0 11.8.4 16.7.8l9 .9-8.3-6.2c-7.6-5.6-8.2-6.3-6.9-7.8.8-1 7.4-9.1 14.6-18.2 17.4-21.8 17.9-22.1 35.4-25 5.9-1 11-2 11.3-2.3.4-.4-3.1-10.1-4.2-11.6-.4-.4-26.7-3.1-29.4-3-.8 0-2.7.4-4.2.9zm23.6 5.1c.2.2.7 1.8 1 3.5l.7 3.1-7.5.6c-4.2.3-9.3 1.4-11.8 2.5-2.4 1.1-12.8 8.8-23.3 17.1-10.4 8.3-19.3 15.1-19.7 15.1-.7 0-5.8-8.1-5.8-9.2 0-.7 38.6-29 42-30.8 4.6-2.5 7.6-3 15.8-2.6 4.6.2 8.5.5 8.6.7z"
          />
        </svg>
      </div>
      <h1 class="header__text">Strrriper</h1>
    </header>
    <main>
      <div class="container">
        <div class="form-container">
          <app-form @update="onUpdate" />
        </div>
      </div>
      <div class="preview-container">
        <app-preview :bg="bg" />
      </div>
    </main>
    <footer class="footer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="footer__logo"
        viewBox="0 0 496 496"
      >
        <path
          d="M452.8 332.8c22.4-21.6 35.2-52 35.2-84.8s-13.6-63.2-35.2-84.8c0-30.4-12-61.6-35.2-84.8s-54.4-35.2-84.8-35.2C311.2 20.8 280.8 8 248 8s-63.2 13.6-84.8 35.2c-30.4 0-61.6 12-84.8 35.2s-35.2 54.4-35.2 84.8C20.8 184.8 8 215.2 8 248s13.6 63.2 35.2 84.8c0 30.4 12 61.6 35.2 84.8 23.2 23.2 54.4 35.2 84.8 35.2 21.6 22.4 52 35.2 84.8 35.2s63.2-13.6 84.8-35.2c30.4 0 61.6-12 84.8-35.2 24-23.2 35.2-53.6 35.2-84.8z"
          fill="#4bf9f4"
        />
        <g fill="#2f5068">
          <path
            d="M248 496c-32.8 0-64-12.8-88-35.2-32.8-.8-64-14.4-87.2-37.6S36 368.8 35.2 336C12.8 312 0 280.8 0 248s12.8-64 35.2-88c.8-32.8 14.4-64 37.6-87.2S127.2 36 160 35.2C184 12.8 215.2 0 248 0s64 12.8 88 35.2c32.8.8 64 14.4 87.2 37.6s36.8 54.4 37.6 87.2c22.4 24 35.2 55.2 35.2 88s-12.8 64-35.2 88c-.8 32.8-14.4 64-37.6 87.2S368.8 460 336 460.8c-24 22.4-55.2 35.2-88 35.2zm0-480.8c-30.4 0-58.4 12-79.2 32.8-1.6 1.6-3.2 2.4-5.6 2.4-30.4 0-58.4 12-79.2 32.8-21.6 21.6-32.8 49.6-32.8 79.2 0 2.4-.8 4-2.4 5.6C27.2 189.6 16 217.6 16 247.2c0 30.4 12 58.4 32.8 79.2 1.6 1.6 2.4 3.2 2.4 5.6 0 30.4 12 58.4 32.8 79.2 21.6 21.6 49.6 32.8 79.2 32.8 2.4 0 4 .8 5.6 2.4 21.6 21.6 49.6 32.8 79.2 32.8s58.4-12 79.2-32.8c1.6-1.6 3.2-2.4 5.6-2.4 30.4 0 58.4-12 79.2-32.8 21.6-21.6 32.8-49.6 32.8-79.2 0-2.4.8-4 2.4-5.6 21.6-21.6 32.8-49.6 32.8-79.2 0-30.4-12-58.4-32.8-79.2-1.6-1.6-2.4-3.2-2.4-5.6 0-30.4-12-58.4-32.8-79.2-21.6-21.6-49.6-32.8-79.2-32.8-2.4 0-4-.8-5.6-2.4-20.8-20.8-48.8-32.8-79.2-32.8z"
          />
          <path
            d="M248 256c-70.4 0-128-57.6-128-128S177.6 0 248 0s128 57.6 128 128-57.6 128-128 128zm0-240.8c-62.4 0-112.8 50.4-112.8 112.8S185.6 240.8 248 240.8 360.8 190.4 360.8 128 310.4 15.2 248 15.2z"
          />
          <path
            d="M248 496c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128-57.6 128-128 128zm0-240.8c-62.4 0-112.8 50.4-112.8 112.8S185.6 480.8 248 480.8 360.8 430.4 360.8 368c0-61.6-50.4-112.8-112.8-112.8z"
          />
          <path
            d="M128 376C57.6 376 0 318.4 0 248s57.6-128 128-128 128 57.6 128 128-57.6 128-128 128zm0-240.8c-62.4 0-112.8 50.4-112.8 112.8S65.6 360.8 128 360.8 240.8 310.4 240.8 248 189.6 135.2 128 135.2z"
          />
          <path
            d="M368 376c-70.4 0-128-57.6-128-128s57.6-128 128-128 128 57.6 128 128-57.6 128-128 128zm0-240.8c-62.4 0-112.8 50.4-112.8 112.8S305.6 360.8 368 360.8 480.8 310.4 480.8 248 430.4 135.2 368 135.2z"
          />
          <path
            d="M163.2 460.8c-34.4 0-66.4-13.6-90.4-37.6s-37.6-56-37.6-90.4c0-34.4 13.6-66.4 37.6-90.4s56-37.6 90.4-37.6c34.4 0 66.4 13.6 90.4 37.6 49.6 49.6 49.6 131.2 0 180.8-24 24-56.8 37.6-90.4 37.6zm0-240.8c-30.4 0-58.4 12-79.2 32.8-21.6 21.6-32.8 49.6-32.8 80s12 58.4 32.8 79.2c21.6 21.6 49.6 32.8 80 32.8s58.4-12 80-32.8c44-44 44-115.2 0-159.2-22.4-20.8-51.2-32.8-80.8-32.8z"
          />
          <path
            d="M332.8 291.2c-34.4 0-66.4-13.6-90.4-37.6s-37.6-56-37.6-90.4 13.6-66.4 37.6-90.4 56-37.6 90.4-37.6 66.4 13.6 90.4 37.6c49.6 49.6 49.6 131.2 0 180.8-24 24-56 37.6-90.4 37.6zm0-240.8c-30.4 0-58.4 12-80 32.8-21.6 21.6-32.8 49.6-32.8 80s12 58.4 32.8 80c21.6 21.6 49.6 32.8 80 32.8s58.4-12 79.2-32.8c44-44 44-115.2 0-159.2-20.8-21.6-48.8-33.6-79.2-33.6z"
          />
          <path
            d="M163.2 291.2c-34.4 0-66.4-13.6-90.4-37.6-49.6-49.6-49.6-131.2 0-180.8 24-24 56-37.6 90.4-37.6s66.4 13.6 90.4 37.6c49.6 49.6 49.6 131.2 0 180.8-24 24-56.8 37.6-90.4 37.6zm0-240.8c-30.4 0-58.4 12-79.2 32.8-44 44-44 115.2 0 159.2 21.6 21.6 49.6 32.8 80 32.8s58.4-12 80-32.8c44-44 44-115.2 0-159.2-22.4-20.8-51.2-32.8-80.8-32.8z"
          />
          <path
            d="M332.8 460.8c-34.4 0-66.4-13.6-90.4-37.6s-37.6-56-37.6-90.4c0-34.4 13.6-66.4 37.6-90.4s56-37.6 90.4-37.6c34.4 0 66.4 13.6 90.4 37.6 49.6 49.6 49.6 131.2 0 180.8-24 24-56 37.6-90.4 37.6zm0-240.8c-30.4 0-58.4 12-80 32.8-21.6 21.6-32.8 49.6-32.8 80s12 58.4 32.8 79.2c21.6 21.6 49.6 32.8 80 32.8s58.4-12 80-32.8c44-44 44-115.2 0-159.2-21.6-20.8-49.6-32.8-80-32.8z"
          />
        </g>
        <path
          d="M136 136c1.6 27.2 12.8 51.2 30.4 69.6 17.6.8 35.2 4.8 51.2 12-7.2-16-11.2-32.8-12-51.2-18.4-17.6-43.2-28.8-69.6-30.4z"
          fill="#ffbc00"
        />
        <path
          d="M160 275.2c12.8-12 28-21.6 44.8-27.2-16.8-6.4-32-15.2-44.8-27.2-26.4.8-51.2 10.4-71.2 27.2 20 16.8 44.8 27.2 71.2 27.2z"
          fill="#ff5b00"
        />
        <path
          d="M205.6 329.6c.8-17.6 4.8-35.2 12-51.2-16 7.2-32.8 11.2-50.4 12-17.6 18.4-28.8 42.4-30.4 69.6 25.6-1.6 50.4-12.8 68.8-30.4z"
          fill="#ffbc00"
        />
        <path
          d="M188.8 272.8c12-2.4 23.2-7.2 33.6-13.6-12 2.4-23.2 7.2-33.6 13.6z"
          fill="#4bf9f4"
        />
        <path
          d="M360 360c-1.6-27.2-12.8-51.2-30.4-69.6-17.6-.8-35.2-4.8-51.2-12 7.2 16 11.2 33.6 12 50.4 18.4 18.4 43.2 29.6 69.6 31.2z"
          fill="#ffbc00"
        />
        <g fill="#4bf9f4">
          <path
            d="M222.4 237.6c-10.4-6.4-21.6-11.2-33.6-13.6 10.4 5.6 21.6 10.4 33.6 13.6zM273.6 258.4c10.4 6.4 21.6 11.2 33.6 13.6-10.4-5.6-21.6-10.4-33.6-13.6z"
          />
        </g>
        <path
          d="M275.2 336c-12-12.8-21.6-28-27.2-44.8-6.4 16.8-15.2 32-27.2 44.8.8 26.4 10.4 51.2 27.2 71.2 17.6-20.8 27.2-46.4 27.2-71.2z"
          fill="#ff5b00"
        />
        <path
          d="M360 136c-27.2 1.6-51.2 13.6-69.6 30.4-.8 17.6-4.8 34.4-12 50.4 16-7.2 32.8-11.2 51.2-12 17.6-17.6 28.8-42.4 30.4-68.8z"
          fill="#ffbc00"
        />
        <path
          d="M336 220.8c-12.8 12-28 21.6-44.8 27.2 16.8 6.4 32 15.2 44.8 27.2 26.4-.8 51.2-10.4 71.2-27.2-20-16.8-44.8-27.2-71.2-27.2z"
          fill="#ff5b00"
        />
        <path
          d="M237.6 222.4c-3.2-12-7.2-23.2-13.6-33.6 2.4 12 7.2 23.2 13.6 33.6z"
          fill="#4bf9f4"
        />
        <path
          d="M220.8 160c12 12.8 21.6 28 27.2 44.8 6.4-16.8 15.2-32 27.2-44.8-.8-25.6-9.6-50.4-27.2-71.2-16.8 20-27.2 44.8-27.2 71.2z"
          fill="#ff5b00"
        />
        <g fill="#4bf9f4">
          <path
            d="M307.2 223.2c-12 2.4-23.2 7.2-33.6 13.6 12-2.4 23.2-7.2 33.6-13.6zM258.4 222.4c6.4-10.4 11.2-21.6 13.6-32.8-5.6 9.6-10.4 20.8-13.6 32.8zM237.6 273.6c-6.4 10.4-11.2 21.6-13.6 33.6 5.6-10.4 10.4-21.6 13.6-33.6zM258.4 273.6c2.4 12 7.2 23.2 13.6 32.8-2.4-11.2-7.2-22.4-13.6-32.8z"
          />
        </g>
        <path
          d="M147.2 289.6c-25.6-3.2-49.6-13.6-68.8-31.2-17.6 20-27.2 44.8-28 71.2 18.4 17.6 43.2 28.8 69.6 30.4 2.4-26.4 12-50.4 27.2-70.4z"
          fill="#1ac4ff"
        />
        <path
          d="M313.6 459.2c-24.8-4-47.2-14.4-65.6-31.2-18.4 16.8-41.6 27.2-65.6 31.2 18.4 13.6 41.6 21.6 65.6 21.6 24.8 0 47.2-8 65.6-21.6z"
          fill="#ff9100"
        />
        <path
          d="M289.6 348.8c-3.2 24.8-13.6 48.8-31.2 68.8 20 17.6 44.8 27.2 71.2 28 17.6-18.4 28.8-43.2 30.4-69.6-26.4-2.4-50.4-12-70.4-27.2z"
          fill="#1ac4ff"
        />
        <path
          d="M237.6 417.6c-16.8-19.2-28-43.2-31.2-68.8-20 15.2-44 24.8-70.4 26.4 1.6 27.2 12.8 51.2 30.4 69.6 26.4 0 51.2-9.6 71.2-27.2z"
          fill="#4bf9f4"
        />
        <g fill="#ff6d00">
          <path
            d="M444 350.4c-19.2 14.4-43.2 23.2-68.8 24.8-1.6 25.6-10.4 48.8-24.8 68.8 23.2-4 44.8-14.4 61.6-31.2 18.4-17.6 28-39.2 32-62.4zM145.6 444c-14.4-19.2-23.2-43.2-24.8-68.8-25.6-1.6-48.8-10.4-68.8-24.8 4 23.2 14.4 44.8 31.2 61.6 17.6 17.6 39.2 28 62.4 32z"
          />
        </g>
        <path
          d="M480.8 248c0-24.8-8-47.2-21.6-65.6-3.2 24-13.6 47.2-31.2 65.6 16.8 19.2 27.2 42.4 31.2 65.6 13.6-18.4 21.6-40.8 21.6-65.6z"
          fill="#ff9100"
        />
        <path
          d="M417.6 258.4c-19.2 16.8-43.2 28-68.8 31.2 15.2 20 24.8 44 26.4 70.4 27.2-1.6 51.2-12.8 69.6-30.4 0-25.6-9.6-50.4-27.2-71.2z"
          fill="#4bf9f4"
        />
        <path
          d="M350.4 52c14.4 19.2 23.2 43.2 24.8 68.8 25.6 1.6 48.8 10.4 68.8 24.8-3.2-22.4-13.6-44.8-31.2-61.6-17.6-17.6-38.4-28-62.4-32z"
          fill="#ff6d00"
        />
        <path
          d="M258.4 78.4c17.6 20 28 44 31.2 68.8 20-15.2 44-24.8 70.4-26.4-1.6-27.2-12.8-51.2-30.4-69.6-26.4 0-51.2 9.6-71.2 27.2z"
          fill="#4bf9f4"
        />
        <path
          d="M182.4 36.8c24.8 4 47.2 14.4 65.6 31.2 18.4-16.8 41.6-27.2 65.6-31.2C295.2 23.2 272 15.2 248 15.2c-24.8 0-47.2 8-65.6 21.6z"
          fill="#ff9100"
        />
        <path
          d="M445.6 166.4c-18.4-17.6-43.2-28.8-69.6-30.4-1.6 26.4-11.2 50.4-26.4 70.4 25.6 3.2 49.6 13.6 68.8 31.2 16.8-20.8 26.4-45.6 27.2-71.2z"
          fill="#1ac4ff"
        />
        <path
          d="M15.2 248c0 24.8 8 47.2 21.6 65.6 4-24.8 14.4-47.2 31.2-65.6-16.8-19.2-27.2-42.4-31.2-65.6-13.6 18.4-21.6 40.8-21.6 65.6z"
          fill="#ff9100"
        />
        <path
          d="M206.4 147.2c3.2-25.6 13.6-49.6 31.2-68.8-20-17.6-44.8-27.2-71.2-28-17.6 18.4-28.8 43.2-30.4 69.6 26.4 2.4 50.4 12 70.4 27.2z"
          fill="#1ac4ff"
        />
        <path
          d="M78.4 237.6c19.2-16.8 43.2-28 68.8-31.2-15.2-20-24.8-44-26.4-70.4-27.2 1.6-51.2 12.8-69.6 30.4 0 25.6 9.6 50.4 27.2 71.2z"
          fill="#4bf9f4"
        />
        <path
          d="M52 145.6c19.2-14.4 43.2-23.2 68.8-24.8 1.6-25.6 10.4-48.8 24.8-68.8-23.2 4-44.8 14.4-61.6 31.2-17.6 17.6-28 39.2-32 62.4z"
          fill="#ff6d00"
        />
      </svg>
      <p>
        {{ new Date().getFullYear() }}
        Made with
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
        by &nbsp; <a href="https://codeguru.info" target="_blank">Codeguru</a>
      </p>
    </footer>
  </div>
</template>

<script>
import AppForm from "@/components/AppForm.vue";
import AppPreview from "@/components/AppPreview.vue";

export default {
  name: "App",

  components: {
    AppForm,
    AppPreview
  },

  data() {
    return {
      bg: {
        angle: "45",
        lines: [
          {
            size: 20,
            color: "#ffffff"
          },
          {
            size: 20,
            color: "#000000"
          }
        ]
      }
    };
  },

  methods: {
    onUpdate(e) {
      this.bg = e;
    }
  }
};
</script>

<style>
html {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji;
}

h1,
h2,
h3,
h4 {
  margin: 0;
  font-family: "Kanit";
  text-transform: uppercase;
}

.main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header__logo svg {
  width: 200px;
}

.header__text {
  margin-top: -60px;
  letter-spacing: 4px;
}

main {
  flex-grow: 1;
  position: relative;
  z-index: 1;
  background-color: white;
}

.container {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.preview-container {
  padding: 2rem;
}

.btn {
  appearance: none;
  border: none;
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 1px solid rgb(209, 213, 219);
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  color: rgb(55, 65, 81);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
}

.btn svg {
  width: 20px;
  margin-right: 8px;
}

.btn--big {
  padding: 16px 24px;
  font-size: 16px;
  text-transform: uppercase;
}

.btn--big svg {
  width: 24px;
}

.btn--color {
  background-color: blueviolet;
  color: white;
}

.footer {
  position: sticky;
  bottom: 0;
  text-align: center;
  padding: 1em;
}

.footer p {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer p svg {
  width: 1em;
  fill: red;
  stroke: none;
  margin: 0 0.2em;
}

.footer__logo {
  width: 40px;
  margin-bottom: 1em;
}

a {
  color: inherit;
}
</style>
